import { render, staticRenderFns } from "./newsDetail.vue?vue&type=template&id=3cd14dfc&scoped=true&"
import script from "./newsDetail.vue?vue&type=script&lang=ts&"
export * from "./newsDetail.vue?vue&type=script&lang=ts&"
import style0 from "./newsDetail.vue?vue&type=style&index=0&id=3cd14dfc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd14dfc",
  null
  
)

export default component.exports